import React from "react";
import styles from "./VersionNumber.module.scss";

export const version = "v1.9.17";

export const VersionNumber = () => {
	return (
		<div className={styles.versionNumber} title="Version Number">
			{version}
		</div>
	);
};
